import React from "react";
import LoginForm from "../component/LoginForm";
import Logo from "../assets/logo.png";

const Login = () => {
  return (
    <section section="bg-gray-100 p">
      <div className="flex justify-center md:justify-start px-6 py-2">
        <div className="w-48 h-16 md:w-64 md:h-20">
          <img
            src={Logo}
            alt="vas2nets logo"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      <section className="px-10 flex flex-col justify-center min-h-screen">
        <LoginForm />
      </section>
    </section>
  );
};

export default Login;
